import { BOSDK } from '@alien-platform/bo-sdk-v2';

// 1. Augment the global type for this specific file
const globalForSdk = globalThis as typeof globalThis & {
  boSdkInstance: Promise<BOSDK> | undefined;
};

export async function getBoSdkV2Instance(): Promise<BOSDK> {
  if (!globalForSdk.boSdkInstance) {
    globalForSdk.boSdkInstance = BOSDK.getInstance({
      baseUrl: `${process.env.APIM_BASE_URL}`,
      env: `${process.env.ENV}` as 'STAGE' | 'DEV' | 'PROD',
    });
  }

  return globalForSdk.boSdkInstance;
}
